import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

interface EditSmsNotificationsParams {
  client_id: string;
  enabled: boolean;
  smsProvider?: string;
  apiKey1?: string;
  apiKey2?: string;
}

export const editSmsNotifications = async ({
  client_id,
  enabled,
  smsProvider,
  apiKey1,
  apiKey2
}: EditSmsNotificationsParams) => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const uri = `${config.uri.base_url}/clients/${client_id}/edit-sms-notifications`;
    const body: any = { enabled };

    if (smsProvider !== undefined) body.smsProvider = smsProvider;
    if (apiKey1 !== undefined) body.apiKey1 = apiKey1;
    if (apiKey2 !== undefined) body.apiKey2 = apiKey2;

    const options = {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(body)
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
